module.exports = __webpack_public_path__ + "img/cancel.5afce04a.svg";